import { Button, Drawer, Form, InputNumber, Space } from "antd";
import { useMapboxContext } from "../context/mapbox-context";

const DrawerFilter = () => {
    const { isOpenFilterDrawer, lotArea, setIsOpenFilterDrawer, setLotArea } = useMapboxContext();
    const [form] = Form.useForm();

    const onClose = () => {
        setIsOpenFilterDrawer(!isOpenFilterDrawer);
    }

    const onFinish = (values: any) => {
        setLotArea(values.lotArea)
    };

    return (<Drawer open={isOpenFilterDrawer} onClose={onClose} width={"30%"} title={<div style={{ color: "white" }}>Filter Lots</div>} style={{ backgroundColor: "black", color: "white" }}>
        <Form form={form} layout="horizontal" autoComplete="off" onFinish={onFinish}>
            <Form.Item name="lotArea" label={<div style={{ color: "white" }}>Lot Area</div>} rules={[{ required: true }]} >
                <InputNumber />
            </Form.Item>
            <Form.Item>
                <Space>
                    <Button htmlType="submit" type="primary">Search</Button>
                    <Button htmlType="reset">Reset</Button>
                </Space>
            </Form.Item>
        </Form>
    </Drawer>)

}

export default DrawerFilter;